import MoveTo from "moveto";
let firsttime = true

const moveTo = new MoveTo({
    tolerance: 80,
    duration: 600
});
export const movetoInit = () => {
    let triggers
    if (firsttime) {
        triggers = document.querySelectorAll('a[href^="#"]');
        firsttime = false
    } else {
        triggers = document.querySelectorAll('main a[href^="#"]');
    }
    for (var i = 0; i < triggers.length; i++) {
        moveTo.registerTrigger(triggers[i]);
    }
}
